<template>
  <rect
    :x = "getPreviousLineSegmentsLength"
    :y = "0"
    :width = "Math.max(getThisLineSegmentLength, 0)"
    height = "30"
    :fill = "getCircleColor"
    fill-opacity=".5"
    :id="'pipe' + num"
    @mouseover="handleMouseOver"
    @mouseout="handleMouseOut"
    @click="handleClick"
    @contextmenu="handleContextMenu"
    ref="rect"
    class="isMonochrome"
  />
  <clipPath :id="getClipId">
    <rect
      :x="getPreviousLineSegmentsLength"
      y="0"
      :width="Math.max(getThisLineSegmentLength, 0)"
      height="30"
    />
  </clipPath>
  <rect
    :x="getPreviousLineSegmentsLength + 7"
    :y="8"
    width="80"
    height="13"
    fill="white"
    fill-opacity=".85"
  />
  <text
    :x="getPreviousLineSegmentsLength + 10"
    y="18"
    :clip-path="getClipUrl"
    class="pipe-text">P{{ num+1 }}&nbsp;&nbsp;&nbsp;{{ (filterLength((segment.value))).toFixed(2) }}&nbsp;{{ lengthUnit }}
  </text>
  <rect
    :x="getPreviousLineSegmentsLength + 7"
    :y="8"
    width="18"
    height="13"
    fill="none"
    stroke="black"
    stroke-width="1"
  />
  <line
    :x1 ="getPreviousLineSegmentsLength"
    :y1 = "getYOffset"
    :x2 = "getPreviousLineSegmentsLength + getThisLineSegmentLength"
    :y2 = "getYOffset"
    :style = "getLineColor"
    class="line"
  />
  <line
    :x1 ="getPreviousLineSegmentsLength + getThisLineSegmentLength"
    y1 = 0
    :x2 = "getPreviousLineSegmentsLength + getThisLineSegmentLength"
    :y2 = "getYOffset"
    :style = "getLineColor"
    class="line"
  />
  <circle
    :cx = "getPreviousLineSegmentsLength + getThisLineSegmentLength"
    :cy = "getYOffset"
    r = "20"
    fill = "var(--inlet)"
    v-if = "getInletState"
    pointer-events="visible"
  />
  <NESWArrows
    :fill = "getCircleColor"
    pointer-events="visible"
    :transform="getGTranslation"
    @mousedown="handleMouseDown"
    @touchstart="handleMouseDown"
    :id="getCircleID"
    ref="circle"
    :direction="'ew'"
    :num="$props.num"
  />
  <PipeLine
    :num="$props.num"
    :segment="$props.segment"
    :transform="getGTranslation"
    ref="pipeLine"
    :parent="this"
  />
</template>

<script>
import { useSegmentStore } from '@/store/SegmentStore';
import { useSettingsStore } from '@/store/SettingsStore';
import { useInputStore } from '@/store/InputStore';
import PipeLine from '@/components/layout/pressure_flow_chart/pressure_flow_chart_components/PipeLine.vue';
import NESWArrows from '@/components/layout/pipe_editor/pipe_editor_components/NESWArrows.vue';
import * as UnitConversion from '@/services/UnitConversionService';
import { circles } from 'svg-patterns';
import {usePrintStore} from '@/store/PrintStore';

export default {
  name: 'pipe',
  props: [
    'segment',
    'num',
    'id'
  ],
  components : {
    NESWArrows,
    PipeLine
  },
  data () {
    return {
      x1: 50,
      y1: 100,
      x2: 200,
      y2: 100,
      startCircleX : 0,
      startMouseX: 0,
      pattern: null
    };
  },
  mounted () {
    document.getElementById('editorHolder').append(this.$refs.circle.$el);
    let pipeLinesHolder = document.getElementById('pipe-lines-holder');
    pipeLinesHolder.prepend(this.$refs.pipeLine.$el, 'pipe line');
    this.pattern = circles(useSegmentStore().getPatterns[this.segment.pattern]);
  },
  beforeUnmount () {
    this.$refs.circle.$el.remove();
    this.$refs.pipeLine.$el.remove();
  },
  computed : {
    lengthUnit () {
      return useSettingsStore().getLengthUnit;
    },
    getGTranslation () {
      return 'translate(' + parseInt(this.getPreviousLineSegmentsLength + this.getThisLineSegmentLength + .5) + ',' + this.getYOffset + ')';
    },
    getCircleID () {
      return 'pipe-circle-' + this.$props.num;
    },
    getPreviousLineSegmentsLength () {
      return useSegmentStore().getPreviousLineSegmentsLength(this.$options.name, this.$props.num) * this.getMagScale;
    },
    getMagScale () {
      return useSegmentStore().getMagScale;
    },
    getThisLineSegmentLength () {
      return useSegmentStore().getSegmentOfType(this.$options.name, this.$props.num).value * this.getMagScale;
    },
    getLineColor () {
      const lineWidth = 3;
      return 'stroke:rgb(' + useSegmentStore().hexToRgb(this.$props.segment.color)  + ');stroke-width:' + lineWidth ;
    },
    getCircleColor () {
      if (useSegmentStore().getPatternReferences[this.segment.pattern]) {
        return useSegmentStore().getPatternReferences[this.segment.pattern].url() ;
      }
      return useSegmentStore().getPatternReferences[0].url();
    },
    getYOffset () {
      return useSegmentStore().getPipeEditorHeight * .2;
    },
    getInletState () {
      if (useSegmentStore().getScaledInletPosition === useInputStore().getXAxisGap) {
        return false;
      }
      if (useSegmentStore().numberOfSegmentsOfType('pipe') === 1) {
       return false;
      }
      return this.$props.segment.isInlet;
    },
    getClipId () {
      return 'clip-pipe' + '-' + this.$props.num;
    },
    getClipUrl () {
      return 'url(#' + this.getClipId + ')';
    }
  },
  methods: {
    filterLength (length) {
      return (UnitConversion.FilterLength(length, useSettingsStore().getLengthUnit));
    },
    highlight () {
      this.$refs.rect.classList.add('selected');
    },
    removeHighlight () {
      this.$refs.rect.classList.remove('selected');
    },
    handleMouseOver (e) {
      e.stopImmediatePropagation();
      const segmentStore = useSegmentStore();
      segmentStore.setSelectedPipeNum(this.$props.num);
      if (useSegmentStore().getSegments('pipe').length === 4) { return; }
      segmentStore.setAllowSplit(true);
    },
    handleMouseOut (e) {
      const segmentStore = useSegmentStore();
      if (!segmentStore.getContextVisible) {
        e.stopImmediatePropagation();
        segmentStore.setAllowSplit(false);
        segmentStore.setSelectedPipeNum(null);
      }
    },
    handleMouseDown (e) {
      if (usePrintStore().getPrintIsOpen) { return; }
      if (this.segment.isInlet) { return; }
      if (e.touches) { e = e.touches[0]; }
      this.startCircleX = this.segment.value;
      this.startMouseX = e.clientX;
      useSegmentStore().setSelectedPipeNum(this.$props.num);
      if (e.radiusX) {
        window.addEventListener('touchmove', this.handleMouseMove);
        window.addEventListener('touchend', this.handleMouseUp);
      } else {
        window.addEventListener('mousemove', this.handleMouseMove);
        window.addEventListener('mouseup', this.handleMouseUp);
      }
    },
    handleMouseMove (e) {
      if (e.touches) { e = e.touches[0]; }

      // x-axis with bounds
      let startValue = this.segment.value;
      let offset = (this.startMouseX - e.clientX) / this.getMagScale;
      let newValue = this.startCircleX - offset;
      if (newValue < 0) { newValue = 0; }
      let diff = newValue - startValue;
      const segmentStore = useSegmentStore();

      // todo: implement last point bounds

      if (this.$props.num === segmentStore.numberOfSegmentsOfType('pipe') - 1) {
        this.segment.value = newValue;
        return;
      }
      let nextSegment = segmentStore.getSegmentOfType('pipe', this.$props.num + 1);
      if (nextSegment !== undefined && nextSegment.value - diff < 2) { return; }
      if (newValue < 2) { return; }
      nextSegment.value -= diff;
      this.segment.value = newValue;
    },
    handleMouseUp (e) {
      const segmentStore = useSegmentStore();
      segmentStore.setSelectedPipeNum(null);
      segmentStore.updateSlopes();
      useInputStore().sprinklerCalc();
      if (e.touches) {
        window.removeEventListener('touchmove', this.handleMouseMove);
        window.removeEventListener('touchend', this.handleMouseUp);
      } else {
        window.removeEventListener('mousemove', this.handleMouseMove);
        window.removeEventListener('mouseup', this.handleMouseUp);
      }
    },
    handleClick () {
      const segmentStore = useSegmentStore();
      if (!segmentStore.getAllowSplit) { return; }
      useSegmentStore().splitPipe(segmentStore.getSplitPosition);
    },
    handleContextMenu (e) {
      e.preventDefault();
    }
  }
};
</script>

<style scoped>
.line {
  pointer-events: none;
}
.pipe-text {
  font-family: "Heebo", sans-serif;
  font-size: 65%;
  font-weight: bold;
  user-select: none;
  pointer-events: none;
}
</style>

<style>
.red {
  font: .8em serif;
  fill: black;
  user-select: none;
  pointer-events: none;
}
.selected {
  stroke: black;
  stroke-width: 3px;
}
</style>

<script setup lang="ts">
</script>